var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 9.4855V30.5145C40 35.7534 35.7533 40 30.5145 40H9.48549C4.24664 40 0 35.7534 0 30.5145V9.4855C0 4.24665 4.24664 0 9.48549 0H30.5145C35.7533 0 40 4.24665 40 9.4855Z",
    fill: "url(#paint0_linear_4482_194538)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7177 6.39557H14.3553C10.0979 6.39557 6.63428 9.8592 6.63428 14.1174V25.4798C6.63428 29.7372 10.0979 33.2017 14.3553 33.2017H25.7177C29.9751 33.2017 33.4387 29.7381 33.4387 25.4798V14.1166C33.4387 9.8592 29.9751 6.39557 25.7177 6.39557ZM30.7036 25.479C30.7036 28.2282 28.467 30.4648 25.7177 30.4648H14.3553C11.6061 30.4648 9.36945 28.2282 9.36945 25.479V14.1166C9.36945 11.3674 11.6061 9.13075 14.3553 9.13075H25.7177C28.467 9.13075 30.7036 11.3674 30.7036 14.1166V25.479Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0357 13.5734C16.6035 13.5734 13.8113 16.3657 13.8113 19.7979C13.8113 23.2301 16.6035 26.0223 20.0357 26.0223C23.4679 26.0223 26.2602 23.2301 26.2602 19.7979C26.2602 16.3657 23.4679 13.5734 20.0357 13.5734ZM20.0357 23.1606C18.1811 23.1606 16.673 21.6525 16.673 19.7979C16.673 17.9433 18.1811 16.4351 20.0357 16.4351C21.8903 16.4351 23.3985 17.9433 23.3985 19.7979C23.3985 21.6525 21.8895 23.1606 20.0357 23.1606Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0111 10.874C25.9916 10.874 25.1648 11.7009 25.1648 12.7204C25.1648 13.7399 25.9916 14.5667 27.0111 14.5667C28.0306 14.5667 28.8575 13.7399 28.8575 12.7204C28.8575 11.7009 28.0315 10.874 27.0111 10.874Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4482_194538",
    x1: 34.3339,
    y1: 7.796,
    x2: 5.55717,
    y2: 32.2963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8237E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0772,
    stopColor: "#9931CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2542,
    stopColor: "#C925A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3895,
    stopColor: "#E71D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4661,
    stopColor: "#F21A80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89D2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.05384ff83392fca404f479f75daa6d80.svg";
export { ForwardRef as ReactComponent };